import {Button} from '@mui/material'
import Device from 'pages/install/modules/asModalComponents/device'
import Efos from 'pages/install/modules/asModalComponents/efos'
import NormalAs from 'pages/install/modules/asModalComponents/normalAs'
import {useState} from 'react'

const AsDynamicComponent = (props: any) => {
  const {type, asSubmit, set, setRenderStep, getPosition} = props
  const [selected, setSelected] = useState<any>(false)

  // const resultAsContent = () => {
  //   switch (type) {
  //     case 1:
  //       return <Efos asSubmit={asSubmit} set={set} />
  //     case 2:
  //       return <Device asSubmit={asSubmit} set={set} />
  //     case 3:
  //       return <Device asSubmit={asSubmit} set={set} />
  //     case 4:
  //       return <Efos asSubmit={asSubmit} set={set} />
  //     case 5:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //     case 6:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //     case 7:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //     case 8:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //     case 9:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //     case 10:
  //       return <NormalAs asSubmit={asSubmit} set={set} />
  //   }
  // }

  const resultAsContent = () => {
    switch (type) {
      case 1:
        return (
          <Efos asSubmit={asSubmit} set={set} setSelected={setSelected} getPosition={getPosition} />
        )
      case 2:
        return (
          <Device
            asSubmit={asSubmit}
            set={set}
            setSelected={setSelected}
            getPosition={getPosition}
          />
        )
      case 3:
        return (
          <Device
            asSubmit={asSubmit}
            set={set}
            setSelected={setSelected}
            getPosition={getPosition}
          />
        )
      case 4:
        return (
          <Efos asSubmit={asSubmit} set={set} setSelected={setSelected} getPosition={getPosition} />
        )
      case 5:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
      case 6:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
      case 7:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
      case 8:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
      case 9:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
      case 10:
        return <NormalAs asSubmit={asSubmit} set={set} getPosition={getPosition} />
    }
  }

  return (
    <article>
      {resultAsContent()}
      <div
        style={{
          position: 'sticky',
          bottom: 0,
          background: '#fff',
          paddingTop: 8,
          paddingBottom: 8,
          width: '100%',
        }}
      >
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          disabled={type <= 4 && !selected}
          onClick={() => {
            if (type >= 5 && type <= 10) {
              // normalAs: skip image edit, go directly to final confirm
              setRenderStep(3)
            } else if (asSubmit?.deviceType === 'analog') {
              setRenderStep(2)
            } else if (asSubmit?.deviceType === 'digital') {
              setRenderStep(3)
              set((prev: any) => ({
                ...prev,
                idxDate: '20230626',
                xstart: 0,
                ystart: 0,
                xend: 0,
                yend: 0,
                recognizedType: null,
                rotate: 0,
              }))
            }
          }}
        >
          {asSubmit?.resultIdxName} 완료
        </Button>
      </div>
    </article>
  )
}

export default AsDynamicComponent
